import classNames from "classnames";
import {ReactNode} from "react";

import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

import styles from "./CardStack.module.scss";

export type CardStackColumns = {sm: number; md: number; lg: number; xl: number; xxl?: number};

interface CardStack {
  children: ReactNode;
  columns?: CardStackColumns;
  className?: string;
}

// If you use the columns prop the stack will layout with a number of columns based on screen size.
// If you select a number of columns that is not divisible by the number of cards, the last row will have empty spaces.

// If no columns prop is provided the stack will layout using flexbox and wrap the cards. This will attempt to fit as many cards
// in a row as possible based on the available width and expend the cards to fill the final row. Best for 3 Cards or less.
export const CardStack = ({children, columns, className}: CardStack) => {
  let cssVars: Record<string, number> = {};

  if (columns) {
    cssVars = {
      "--kpi-card-stack-small-columns": columns.sm,
      "--kpi-card-stack-medium-columns": columns.md,
      "--kpi-card-stack-large-columns": columns.lg,
      "--kpi-card-stack-xlarge-columns": columns.xl,
      "--kpi-card-stack-xxlarge-columns": columns.xxl ?? columns.xl,
    };
  }

  return (
    <UpErrorBoundary>
      <div
        style={cssVars}
        className={classNames(
          styles.kPICardStack,
          {[styles.kPICardStackFlex]: !columns},
          {[styles.kPICardStackGrid]: columns},
          className
        )}
      >
        {children}
      </div>
    </UpErrorBoundary>
  );
};
